'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./notice.scss');

var _icon = require('../icon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _iconButton = require('../icon-button/icon-button');

var _iconButton2 = _interopRequireDefault(_iconButton);

var _title = require('../title/title');

var _title2 = _interopRequireDefault(_title);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var icons = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'information',
  instruction: 'information',
  hint: 'information'
};

var colors = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
  instruction: 'instruction'
};

function Notice(_ref) {
  var border = _ref.border,
      background = _ref.background,
      children = _ref.children,
      className = _ref.className,
      title = _ref.title,
      type = _ref.type,
      shadow = _ref.shadow,
      onClose = _ref.onClose,
      props = _objectWithoutProperties(_ref, ['border', 'background', 'children', 'className', 'title', 'type', 'shadow', 'onClose']);

  var classes = (0, _classnames2.default)('notice', background && 'notice--background-' + background, border && 'notice--border', type && 'notice--type-' + type, shadow && 'notice--shadow', className);

  var titleDensity = children ? 'compact' : 'none';

  // TODO: REMOVE hide-on-mobile

  return _react2.default.createElement(
    'div',
    _extends({ className: classes }, props),
    _react2.default.createElement(
      'span',
      { className: 'notice__icon-wrapper' },
      _react2.default.createElement(_icon2.default, { name: icons[type], size: '30', className: 'notice__icon', color: colors[type] })
    ),
    _react2.default.createElement(
      'div',
      { className: 'notice__content' },
      title && _react2.default.createElement(
        _title2.default,
        { level: '6', density: titleDensity, className: 'notice__title', color: colors[type] },
        title
      ),
      children
    ),
    onClose && _react2.default.createElement(_iconButton2.default, {
      icon: 'cross',
      size: 'small',
      shape: 'circle',
      className: 'notice__close-icon hide-on-mobile',
      onClick: onClose
    })
  );
}

Notice.propTypes = {
  background: _propTypes2.default.oneOf(['white', 'light']),
  border: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  title: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['success', 'error', 'warning', 'info', 'instruction', 'hint']),
  shadow: _propTypes2.default.bool,
  onClose: _propTypes2.default.func
};

Notice.defaultProps = {
  background: 'white',
  border: true,
  shadow: true
};

exports.default = Notice;